import { render, staticRenderFns } from "./User_menu.vue?vue&type=template&id=1a7622e7&scoped=true"
import script from "./User_menu.vue?vue&type=script&lang=js"
export * from "./User_menu.vue?vue&type=script&lang=js"
import style0 from "./User_menu.vue?vue&type=style&index=0&id=1a7622e7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7622e7",
  null
  
)

export default component.exports